import { render, staticRenderFns } from "./ReservationFee.vue?vue&type=template&id=3d863770&scoped=true"
import script from "./ReservationFee.vue?vue&type=script&lang=js"
export * from "./ReservationFee.vue?vue&type=script&lang=js"
import style0 from "./ReservationFee.vue?vue&type=style&index=0&id=3d863770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d863770",
  null
  
)

export default component.exports